import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'ubx-datepicker',
    templateUrl: './datepicker.component.html',
    host: { class: 'ubx-datepicker flx-i f-fd:c pd:40' }
})
export class UBXDatepickerComponent implements OnInit {
    titles: Array<string>;
    days: Array<number> = [];

    constructor() { }

    ngOnInit() {
        this.titles = [ 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So' ];
        for (let i = 1; i <= 31; i++) {
            this.days.push(i);
        }
    }
}
